export enum InboundFaxCommunicationMethod {
  standardFax = 'Standard Fax',
  ciox = 'CIOX',
  mro = 'MRO',
  ironMountain = 'Iron Mountain',
  shareCare = 'ShareCare',
  otherThirdParty = 'Other 3rd Party',
  email = 'Email',
}
